<template>
<div class="position-relative overflow-hidden" :dir="isHebrew ? 'rtl' : 'ltr'">
    <head>
      <meta name="robots" content="noindex, nofollow" />
    </head>
    <NavBar/>
    <div>
      <img
        alt=""
        class="background-image"
        src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba">
    </div>
    <ImageBanner :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fride-info-banner.jpg?alt=media&token=b765e21f-2604-4874-a029-3453357e4897'"
                 :dir="isHebrew ? 'rtl' : 'ltr'"
                 :paragraph="t('privateTripSubtitle')"
                 size="240px" :title="t('privateTripTitle')"/>
  <b-container>
    <b-row class="justify-content-center">
      <b-col col md="6">
        <b-form>
          <b-form-group
            id="label-title"
            :class="isHebrew ? 'text-right' : 'text-left'"
            label-for="title"
            :dir="isHebrew ? 'rtl' : 'ltr'"
          >
            <template
              v-if ="this.isAppLoggedIn"
              #label
            >
              <p>{{ t('welcomeToPrivateTrip') }}</p>
              <p>{{ t('noPermissionMessage') }}</p>
            </template>
            <template
              v-else
              #label
            >
              <p>{{ t('welcomeToPrivateTrip') }}</p>
              <p>{{ t('loginToViewTrip') }}</p>
              <p>{{ t('afterLoginMessage') }}</p>            </template>
          </b-form-group>
        </b-form>
        <div  v-if ="this.isAppLoggedIn" >
          <PrimaryButton 
            class="w-100 mb-5"
            @click="goToRideRegistry"
          >
            {{ t('purchaseTrip') }}
          </PrimaryButton>
        </div>
        <PrimaryButton
          v-else
          @click="this.openLoginForm"
          class="w-100 mb-5"
        >
          {{ t('loginOrRegister') }}
        </PrimaryButton>
      </b-col>
    </b-row>
  </b-container>
  <AppFooter
    v-if="!isSubdomain"
  />
</div>
</template>

<script>
import ImageBanner from "@/components/ImageBanner/ImageBanner.vue";
import PrimaryButton from "@/components/Buttons/PrimaryButton.vue";
import NavBar from "@/components/NavBar.vue";
import AppFooter from "@/components/Template/AppFooter.vue";
import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: 'PrivatePageLanding',
  mixins: [translationMixin],
  components: {
    AppFooter,
    PrimaryButton,
    ImageBanner,
    NavBar,
    },
  computed: { ...mapGetters([ 'isAppLoggedIn',
                              'rideRedirectLink',
                            ]),
              ...mapGetters("theme",  [ "isSubdomain",
                                      ]),

    },
    methods:
    {
   ...mapActions([ 'openLoginForm',
                    'showModal',
                    'fetchRide',
                    'getRedirectLinkFromRideId',
                    ] ),
    goToRideRegistry() {
      if (this.rideRedirectLink) {
        window.open(this.rideRedirectLink, '_blank');
      } else {
        console.error('Redirect page not found for the given ride ID.');
      }
    },
  },
  data() {
    return {
      rideId: null, // Global parameter to store the ride ID
    };
  },
  watch: {
    isAppLoggedIn(newVal) {
      if (newVal) {
        if (this.isAppLoggedIn && this.rideId) {
          this.$router.push('/single_ride_with_map/'+ this.rideId)
        }
      }
    },
  },
  created() {
    this.rideId = this.$route.params.ride_id;
    this.getRedirectLinkFromRideId( this.rideId );
  },

};
</script>


<style scoped>
</style>